import * as React from "react";
import Image from "next/image";
import { HeaderImage } from "@/types/index";

const HeaderImage: React.FC<{
	data: HeaderImage;
}> = ({ data }) => {
	return (
		<div className="d-flex justify-content-center col-12 col-sm-3">
			<div className="bg-white rounded-4 ">
				<Image
					src={"https:" + data.fields.image?.fields.file?.url}
					alt={data.fields.image?.fields.title ?? ""}
					height={65}
					width={110}
				/>
			</div>
		</div>
	);
};

export default HeaderImage;
